import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[activate]'
})
export class ActivateDirective {

  private _activate;
  @Input('activate')
  public get activate() {
    return this._activate;
  }
  public set activate(value: any) {
    this._activate = value;
    if (value) {
      this.el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' });
      this.el.nativeElement.focus();
    }
  }

  constructor(private el: ElementRef) {
  }
}
